
import { Component, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { IUser } from "@/entities";

@Component({
  name: "top-navbar",
})
export default class TopNavbar extends Vue {
  @Getter("getLoggedUser") loggedUser?: IUser;
  @Action("logout") logout!: () => Promise<void>;

  constructor() {
    super();
  }
}
